import { useEffect } from "react";
import { useBlocker } from "react-router-dom";

/**
 * 저장하지 않은 변경사항이 있을 때 페이지 이탈을 경고하는 훅
 * @param {boolean} hasUnsavedChanges - 저장하지 않은 변경사항이 있는지 여부
 * @param {string} message - 경고 메시지 (선택)
 */
export default function useUnsavedChangesWarning(
  hasUnsavedChanges,
  message = "저장하지 않은 변경사항이 있습니다. 페이지를 떠나시겠습니까?"
) {
  // 브라우저 닫기, 새로고침, 뒤로가기 등 차단
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = message;
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [hasUnsavedChanges, message]);

  // React Router 네비게이션 차단 (메뉴 클릭 등)
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      hasUnsavedChanges && currentLocation.pathname !== nextLocation.pathname
  );

  // 차단된 경우 confirm 대화상자 표시
  useEffect(() => {
    if (blocker.state === "blocked") {
      const shouldLeave = window.confirm(message);
      if (shouldLeave) {
        blocker.proceed();
      } else {
        blocker.reset();
      }
    }
  }, [blocker, message]);

  return blocker;
}
